<template>
  <default-layout>
     <v-layout wrap>
         <v-flex xs12>
             <blog-menu-bar></blog-menu-bar>
         </v-flex>

         <v-flex xs12 class="pt-5">
            <v-card class="elevation-12">
              <v-toolbar dark color="blue darken-1">
                <v-toolbar-title>Create Blog</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-container grid-list-md mx-1>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('title')"
                          data-vv-name="title"
                          v-model="title"
                          label="Title"
                          type="text"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-validate="'required'"
                          :error-messages="errors.collect('url')"
                          data-vv-name="url"
                          v-model="url"
                          label="Slug"
                          type="text"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          v-validate="'required'"
                          :error-messages="errors.collect('short_description')"
                          data-vv-name="short_description"
                          v-model="short_description"
                          label="Short Description"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <ckeditor v-model="description" id="description"
                          data-vv-name="description"  label="Description" :editor="editor" :config="editorConfig"></ckeditor>
                      </v-flex>
                      <!-- video files -->
                      <v-flex xs12>
                        <label class="font-weight-bold">Video Uploads</label>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <label>Only Video file Upload (Maximum size 15MB per file)</label>
                        <v-alert :value="true" v-model="videofileerror" type="error" class="py-2 error" dismissible>Uploaded files must be videos in format & not to exceed 15MB</v-alert>
                        <video-upload @image="setVideoUrl"></video-upload>
                      </v-flex>

                      <v-flex xs12 sm8 v-if="videoUrl">
                          <video
                            v-if="videoUrl"
                            :src="videoUrl"
                            style="width: 150px;" controls=""
                          ></video>
                          <v-btn icon @click="removeVideo()">
                            <v-icon color="red">clear</v-icon>
                          </v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          data-vv-name="video_title"
                          v-model="video_title"
                          label="Video Title"
                          type="text"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          data-vv-name="meta_title"
                          v-model="meta_title"
                          label="Meta Title"
                          type="text"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          data-vv-name="meta_description"
                          v-model="meta_description"
                          label="Meta Description"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <label class="font-weight-bold">Add Video Cover Image</label>
                      </v-flex>
                      <v-flex sm4>
                        <v-alert :value="true"  v-model="blogvideocovererror" type="error" class="py-2 error" dismissible>Uploaded file must be image in format & not to exceed 10MB</v-alert>
                        <file-upload @image="setVideoCoverImage" title="Browse Video Cover Image"></file-upload>
                      </v-flex>
                      <v-flex sm12 >
                        <label class="red--text"> PLEASE DO NOT UPLOAD PHOTOS WITH YOUR PHONE OR EMAIL CONTACTS</label>
                      </v-flex>
                      <v-flex xs12 sm12 v-if="blogVideoCoverImageUrl">
                        <v-layout wrap>
                          <v-flex xs12 sm4>
                            <img
                              v-if="blogVideoCoverImageUrl"
                              :src="blogVideoCoverImageUrl"
                              style="width: 150px; height: 150px; padding: 20px"
                            >
                          </v-flex>
                          <v-flex xs12 sm4>
                            <v-btn icon @click="removeVideoCoverImage">
                              <v-icon color="red">clear</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <v-text-field
                          v-model="blogVideoMetaTitle"
                          label="Video Meta Title"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                            <v-textarea v-model="blogVideoMetaDescription" label="Video Meta Description"></v-textarea>
                      </v-flex>
                      <v-flex xs12 sm12>
                        <span style="color: red">{{err_msg}}</span>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-btn color="blue darken-1" @click="save" dark>Submit</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
         </v-flex>
     </v-layout>
  </default-layout>
</template>
<script>
import { mapGetters } from "vuex";
import BlogMenuBar from '../_components/blog_menu.vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import VideoUpload from "@/components/shared/video-file-uploader.vue";
import FileUpload from "@/components/shared/file-uploader.vue";

export default {
  name: 'BlogCreatePage',
  components: {
    BlogMenuBar,
    CKEditor,
    VideoUpload,
    FileUpload
  },
  computed: {
    ...mapGetters(["user"])
  },
  data () {
    return {
      toolbarColor: null,
      title: null,
      short_description: null,
      description: null,
      author: null,
      meta_description: null,
      meta_title: null,
      url: null,
      err_msg: null,
      editor: ClassicEditor,
      editorConfig: {
        image: {
            styles: [
                'alignLeft', 'alignCenter', 'alignRight'
            ],
            resizeOptions: [
                {
                    name: 'imageResize:original',
                    label: 'Original',
                    value: null
                },
                {
                    name: 'imageResize:50',
                    label: '50%',
                    value: '50'
                },
                {
                    name: 'imageResize:75',
                    label: '75%',
                    value: '75'
                }
            ],
            toolbar: [
                'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
                '|',
                'imageResize',
                '|',
                'imageTextAlternative',
                '|',
                'linkImage'
            ]
        },
        link: { addTargetToExternalLinks: true },
      },
      videoImage: null,
      videoUrl: null,
      videofileerror: false,
      video_title: null,
      blogvideocovererror: false,
      blogVideoCoverImage: null,
      blogVideoCoverImageUrl: null,
      blogVideoMetaDescription: null,
      blogVideoMetaTitle: null,  
    };
  },
  methods: {
    navigateHome() {
      window.location = this.webUrl;
    },
    save() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
            // save
            const blogData = {
              title: this.title,
              short_description: this.short_description,
              description: this.description,
              meta_title: this.meta_title,
              meta_description: this.meta_description,
              url: this.url,
              userId: this.user._id,
              author: this.user.admin== true ? 'Admin' : 'Editor',
              video_title: this.video_title,
              blogVideoMetaTitle: this.blogVideoMetaTitle,
              blogVideoMetaDescription: this.blogVideoMetaDescription,
            };

            //video files
            const formData = new FormData();
            if(this.videoImage != null) {
              const cm_file = this.videoImage;
              let cbytes = this.videoImage.size;
              let cmimeType = this.videoImage.type;
              let allowedMimeType = ['video/x-flv', 'video/mp4', 'application/x-mpegURL', 'video/MP2T', 'video/3gpp', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv'];
              if(allowedMimeType.includes(cmimeType) & cbytes<=15*1024*1024) {
                formData.append("blogVideo", this.videoImage);
              }
            }
            formData.append("data", JSON.stringify(blogData));

            if(this.blogVideoCoverImage != null) {
                const cm_file = this.blogVideoCoverImage;
                let cbytes = this.blogVideoCoverImage.size;
                let cmimeType = this.blogVideoCoverImage.type;
                let allowedMimeType = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/gif', 'image/tiff', 'image/webp', 'image/bmp']
                if(allowedMimeType.includes(cmimeType) & cbytes<=10*1024*1024) {
                  formData.append("blogVideoCoverImage", this.blogVideoCoverImage);
                }
              }

            const data = formData;
            // end of video files

            this.loading = true;
            const self = this;
            const res = this.$store
              .dispatch("post", { url: "/blog", data })
              .then(res => {
                self.loading = false;
                if (res.state == true) {
                  this.$router.push(`/blogs`);
                } else {
                  this.err_msg = res.err;
                }
              })
              .finally(() => {});
        }
      });
    },
    setVideoUrl({ image, imageUrl, fileSize }) {
      if(fileSize > 15) {
        this.videofileerror = true;
      } else {
          this.videofileerror = false;
          let cbytes = image.size;
          //const bytes = (this.calculateImageSize(imageUrl));
          let mimeType = imageUrl.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
          let allowedMimeType = ['video/x-flv', 'video/mp4', 'application/x-mpegURL', 'video/MP2T', 'video/3gpp', 'video/quicktime', 'video/x-msvideo', 'video/x-ms-wmv']
          if(allowedMimeType.includes(mimeType) & cbytes <= 15*1024*1024) {
            this.videoImage = image;
            this.videoUrl = imageUrl;
            this.videofileerror = false;
          } else {
            this.videofileerror = true;
          }
      }
    },
    removeVideo(key) {
      this.videoUrl = null;
      this.videoImage = null;
    },
    calculateImageSize(base64String){
      let padding, inBytes, base64StringLength;
      if(base64String.endsWith("==")) padding = 2;
      else if (base64String.endsWith("=")) padding = 1;
      else padding = 0;

      base64StringLength = base64String.length;
      inBytes =(base64StringLength / 4 ) * 3 - padding;
      this.kbytes = inBytes / 1000;
      return this.kbytes / 1000;
    },
    setVideoCoverImage({ image, imageUrl }) {
      const bytes = (this.calculateImageSize(imageUrl));
      let mimeType = imageUrl.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
      let allowedMimeType = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/gif', 'image/tiff', 'image/webp', 'image/bmp']
      if(allowedMimeType.includes(mimeType) & bytes<=10) {
        this.blogVideoCoverImage = image;
        this.blogVideoCoverImageUrl = imageUrl;
        this.blogvideocovererror = false;
      } else {
        this.blogvideocovererror = true;
      }
    },
    removeVideoCoverImage() {
      this.blogVideoCoverImageUrl = null;
      this.blogVideoCoverImage = null;
    },
  },
  created () {
    /*this.$store.dispatch("get", "/user/all/blogs").then(res => {
      this.blogs = res.blogs;
    });*/
  }
}
</script>
